module.exports = __webpack_public_path__ + "static/media/24a.59761235.jpg";